import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllFarmUserSuccess,
  getAllFarmUserFailed,
  GET_ALL_FARM_USER_START,
} from '../../actions/farm'

/**
 * get list farm user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListFarmUserApi = (props) => {
  var uri = `/users/farm`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListFarmUser(action) {
  try {
    const response = yield call(getListFarmUserApi, action?.payload)
    yield put(getAllFarmUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllFarmUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list farm user
 */
export default function* watchGetListFarmUser() {
  yield takeLatest(GET_ALL_FARM_USER_START, doGetListFarmUser)
}
